export default "__VITE_ASSET__5ab6c27e__"